import React from 'react';
import classNames from 'classnames/bind';

import styles from './InlineFiltersShimmer.pcss';

const cx = classNames.bind(styles);

const TAG_WIDTHS_ROW_1 = [88, 104, 72, 96];
const TAG_WIDTHS_ROW_2 = [80, 112, 68, 92];

const InlineFiltersShimmer = ({
  luxe = false,
  ajiogram = false
}: {
  luxe?: boolean;
  ajiogram?: boolean;
}) => {
  const skeletonClass = ajiogram ? 'skeleton-dark' : 'skeleton';
  const skeletonAltClass = ajiogram ? 'skeleton-dark-alt' : 'skeleton-white';

  return (
    <div
      className={cx('shimmer-container', { luxe, ajiogram })}
      data-component="inline-filters-shimmer"
    >
      <div className={cx('header')}>
        <div className={cx(skeletonClass, 'header-title', { luxe })} />
      </div>

      <div className={cx('tags-area')}>
        <div className={cx('tags-row')}>
          {TAG_WIDTHS_ROW_1.map((w, i) => (
            <div
              key={i}
              className={cx(skeletonAltClass, 'tag-pill', { luxe })}
              style={{ width: w }}
            />
          ))}
        </div>
        <div className={cx('tags-row')}>
          {TAG_WIDTHS_ROW_2.map((w, i) => (
            <div
              key={i}
              className={cx(skeletonAltClass, 'tag-pill', { luxe })}
              style={{ width: w }}
            />
          ))}
        </div>
      </div>

      <div className={cx(skeletonClass, 'apply-btn', { luxe })} />
    </div>
  );
};

export default InlineFiltersShimmer;
